import axios from 'axios'

const colecoes = {}

colecoes.find = (params) => {
	const filters = {
		usuario: params && params.usuario ? params.usuario : '',
		objetos: params && params.objetos ? params.objetos : '',
		status: params && params.status ? params.status : '',
		termo: params && params.texto ? params.texto : '',
		quantidade: params && params.quantidade ? params.quantidade : 20,
		ordenarPor: params && params.ordenarPor ? params.ordenarPor : 'dtInsert',
		ordem: params && params.ordem ? params.ordem : 'desc',
		skip: params && params.skip ? params.skip : 0,
		data: params && params.data ? params.data : '',
		onlyRoot: params && params.onlyRoot ? params.onlyRoot : false
	}
	return axios.get('/colecoes', { params: filters })
}

colecoes.findInTree = (params) => {
	const filters = {
		usuario: params && params.usuario ? params.usuario : '',
		status: params && params.status ? params.status : '',
		texto: params && params.texto ? params.texto : '',
		quantidade: params && params.quantidade ? params.quantidade : 20,
		ordenarPor: params && params.ordenarPor ? params.ordenarPor : 'dtInsert',
		ordem: params && params.ordem ? params.ordem : 'desc',
		skip: params && params.skip ? params.skip : 0,
		onlyRoot: params && params.onlyRoot ? params.onlyRoot : false
	}
	return axios.get('/colecoes/em_arvore', { params: filters })
}

colecoes.create = (dados) => axios.post('/colecoes', dados)

colecoes.update = (id, dados) => axios.put(`/colecoes/${id}`, dados)

colecoes.delete = (id) => axios.delete(`/colecoes/${id}`)

colecoes.addObjeto = (id, dados) => axios.post(`/colecoes/${id}/objetos`, dados)

colecoes.obterTodos = (skip, ordem, status) => axios.get(`/colecoes?skip=${skip}&ordem=${ordem}&status=${status}&onlyRoot=false`)

colecoes.obterArvoreObjetos = (id) => axios.get(`/colecoes/${id}/em_arvore`)

colecoes.obterColecaoEmArvore = (skip, take, nome, status, ordenarPor, ordem, usuario) => axios.get(`/colecoes/em_arvore?skip=${skip}&take=${take}&nome=${nome}&status=${status}&ordenarPor=${ordenarPor}&ordem=${ordem}&usuario=${usuario}&onlyRoot=true`)

colecoes.enviarProd = (id) => axios.put(`/colecoes/${id}/enviarProducao`)

colecoes.salvarComentario = (id, dados) => axios.put(`/colecoes/${id}`, dados)

colecoes.deleteObjetoColecao = (idColecao, idObjeto) => axios.delete(`/colecoes/${idColecao}/objetos/${idObjeto}`)

colecoes.salvarComentarioObjetoColecao = (idColecao, idObjeto, dados) => axios.put(`/colecoes/${idColecao}/objetos/${idObjeto}`, dados)

colecoes.reordenarObjetosColecao = (id, dados) => axios.put(`/colecoes/${id}/objetos/reordenar`, dados)

colecoes.clonar = (id) => axios.post(`/colecoes/${id}/clonar`)

export { colecoes }
